<!--  -->
<template>
  <div :class="['pull-list', { inApp: isApp || this.$root.miniprogram }]">
    <common-title titleName="拉新活动列表" :zIndex="1000"> </common-title>

    <div :class="['box']">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" :offset="60"
        @load="onLoad">
        <div class="content" v-for="(item, index) in pullList" :key="index" @click="lookActive(item)">
          <img class="img" :src="item.activityPicture || activityPicture" />
          <div class="right">
            <p class="title ellipsis-2">
              {{ item.activityName }}
            </p>
            <p class="time" v-if="item.startTime">
              活动时间 {{ item.startTime.slice(0, 11) }}-{{ item.endTime.slice(0, 11) }}
            </p>
            <div class="info">
              <div class="num">
                <span>{{ item.joinNumber }}</span><b>人已参与</b>
              </div>
              <button class="btn">进入活动</button>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { getPullNewList } from '@/api/pullNew';

export default {
  components: {},
  data() {
    return {
      examSeasonIdList: [0],
      pageNum: 1,
      pageSize: 20,
      pullList: [],
      finished: false,
      loading: false,
      total: 0,
      activityPicture: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/pullDefault.png',
      isApp: this.$root.$data.isApp,
    };
  },
  computed: {},
  watch: {},
  methods: {
    onLoad() {
      this.getList();
    },
    async getList(examSeasonId) {
      const examSeasonIdList = [0];
      examSeasonIdList.push(examSeasonId);
      this.loading = true;
      const res = await getPullNewList(examSeasonIdList, this.pageNum, this.pageSize, (this.$root.ytMini || this.$root.pullNewType === 2) ? 1 : 0);
      const { data, total } = res.data;
      data.forEach((ele) => {
        const { startTime, endTime } = ele;
        Object.assign(ele, {
          startTime: startTime.replace(/-/g, '.'),
          endTime: endTime.replace(/-/g, '.'),
        });
      });
      this.total = total;
      this.pullList = [...this.pullList, ...data];
      this.loading = false;
      this.pageNum += 1;
      if (total === this.pullList.length) {
        this.finished = true;
      }
    },
    lookActive(item) {
      const { activityId } = item;
      this.$router.push({
        path: '/pullnew/home',
        query: {
          activityId,
        },
      });
    },
  },
  created() { },
  mounted() {
    const { examSeasonId } = this.$route.query;
    this.getList(examSeasonId);
    if (this.$root.ytMini || this.$root.pullNewType === 2) {
      document.title = '云图书吧';
    }
  },
};
</script>
<style lang="scss" scoped>
.pull-list {
  

  width: 100%;

  // height: 100vh;
  // background: #f7f8fc;
  .box {
    padding: 107px 20px 20px 20px;
    overflow: hidden;

    .content {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 678px;
      height: 239px;
      margin: 22px auto;
      padding: 25px;
      background: #fff;
      border-radius: 14px;

      .img {
        width: 181px;
        height: 181px;
        background: #fff;
        border: 2px solid #efefef;
        border-radius: 14px;
      }

      .right {
        position: relative;
        width: 450px;
        height: 191px;
        padding-left: 22px;

        .title {
          color: #333;
          font-weight: 500;
          font-size: 29px;
          line-height: 40px;
        }

        .time {
          padding: 14px 0;
          color: #999;
          font-weight: 400;
          font-size: 22px;
          line-height: 31px;
        }

        .info {
          position: absolute;
          bottom: 0;
          left: 22px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 95%;

          .num {
            display: flex;
            align-items: center;

            span {
              color: #ff7f41;
              font-weight: 600;
              font-size: 22px;
            }

            b {
              color: #999;
              font-weight: 400;
              font-size: 22px;
            }
          }

          .btn {
            padding: 0 20px;
            // width: 125px;
            color: #fff;
            font-weight: 500;
            font-size: 22px;
            line-height: 42px;
            background: #ff7f41;
            border-radius: 21px;
          }
        }
      }
    }
  }
  &.inApp {
    padding-top: 0;

    .box {
      padding-top: 0;
    }
  }
}
</style>
